import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TuiDialogContext } from '@taiga-ui/core';
import { injectContext } from '@taiga-ui/polymorpheus';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'app-dialog-confirm-common',
  templateUrl: './dialog-confirm-common.component.html',
  styleUrls: ['./dialog-confirm-common.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogConfirmCommonComponent extends BaseResizableComponent {
  private readonly context = injectContext<TuiDialogContext<boolean, string>>();

  submit(result: boolean) {
    this.context.completeWith(result);
  }

  get text(): string {
    return this.context.data;
  }
}
